import React from 'react';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import theme from '../../theme';
import { CircularProgress } from '@mui/material';

export const SearchPropertyName = (props) => {

	// style
	const searchStyled = {
		position: 'relative',
		borderRadius: theme.shape.borderRadius,
		backgroundColor: alpha(theme.palette.common.white, 0.15),
		'&:hover': {
			backgroundColor: alpha(theme.palette.common.white, 0.25),
		},
		marginLeft: 0,
		width: '100%',
		[theme.breakpoints.up('sm')]: {
			marginLeft: theme.spacing(1),
			width: 'auto',
		},
	};
	const searchIconWrapperStyled = {
		padding: theme.spacing(0, 2),
		height: '100%',
		position: 'absolute',
		pointerEvents: 'none',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	};
	const styledInputBaseStyled = {
		color: 'inherit',
		'& .MuiInputBase-input': {
			padding: theme.spacing(1, 1, 1, 0),
			// vertical padding + font size from searchIcon
			paddingLeft: `calc(1em + ${theme.spacing(4)})`,
			transition: theme.transitions.create('width'),
			width: '100%',
			[theme.breakpoints.up('sm')]: {
				width: '12ch',
				'&:focus': {
					width: '20ch',
				},
			},
		},
	};

  return (
    <Box sx={searchStyled}>
			<Box sx={searchIconWrapperStyled}>
      	{ props.isSearching ? 
        	<CircularProgress /> :
			<SearchIcon />
  		}
			</Box>
			<InputBase sx={styledInputBaseStyled}
				placeholder="Search…"
				inputProps={{ 'aria-label': 'search' }}
				onKeyDown={event => props.handleInputChange(event)}
			/>
		</Box>
  )
}
